import React from "react"
import DOMPurify from "dompurify"
import Image from "./Image"
import "../../styles/Common/GenericComponenetHeader.less"
export default function GenericComponenetHeader({ BHTTitle = "BHTTitle", BHTContainer = "BHTContainer", BHTarrowStyle = "BHTarrowStyle", ...props }) {
  return (
    <div className={BHTContainer}>
      <div className={BHTTitle} onClick={props.onClick} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.content.title) }} />
      {props.icon ? <Image src={props.content.iconId} className={BHTarrowStyle} alt={""} onClick={props.onClick} width={props.imgwidth} height={props.imgheight}></Image> : ""}
    </div>
  )
}
